const zhCN = {
  pageErrTitle: '页面错误',
  pageErrContent: '信息错误，请返回设备管理列表！',
  backBtn: '返回',
  submitBtn: '提交',

  selectedDevices: '已选设备',

  listDeviceName: '设备名称',
  listDeviceOrg: '所属机构',
  listDeviceOperation: '操作',
  listDeviceRemoveBtn: '移除',

  selectTimeConfig: '选择门禁有效时间',
  listTimeConfigName: '时间配置名称',
  
  batchSetSuccess: 'return "设置成功 " + count + " 台设备！"',
  batchSetFail: 'return "设置失败 " + count + " 台设备！"',
  setFail: '设置失败！'
}
const enUS = {
  pageErrTitle: 'Page Error',
  pageErrContent: 'Page error, please return to the device management list!',
  backBtn: 'Back',
  submitBtn: 'Submit',

  selectedDevices: 'Selected devices',

  listDeviceName: 'Name',
  listDeviceOrg: 'Organization',
  listDeviceOperation: 'Operation',
  listDeviceRemoveBtn: 'Remove',

  selectTimeConfig: 'Select Time Config',
  listTimeConfigName: 'Time Config Name',

  batchSetSuccess: 'return "Set " + count + " devices successfully!"',
  batchSetFail: 'return "Set " + count + " devices failed!"',
  setFail: 'Set failed!'
}

export default { zhCN, enUS }